import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PetitionListComponent } from './petition-list/petition-list.component';
import { PetitionPageComponent } from './petition-page/petition-page.component';
import { PetitionsPerTopicComponent } from '@tytapp/app/pages/petition-pages/petitions-per-topic/petitions-per-topic.component';
import { AllPetitionsComponent } from '@tytapp/app/pages/petition-pages/all-petitions/all-petitions.component';
import { SlugComponent } from '@tytapp/slugs';

const routes: Routes = [
    { path: 'v1', component: PetitionListComponent },
    { path: 'all', component: AllPetitionsComponent },
    { path: 'new', redirectTo: '/polls/new:Petition/edit' },
    { path: ':id', component: PetitionPageComponent },
    { path: ':id/edit', redirectTo: '/polls/:id/edit' },
    { path: ':id/amplify', component: PetitionPageComponent, data: {amplify: true} },
    { path: 'topics/:slug', component: PetitionsPerTopicComponent },
    SlugComponent.outlet('')
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);
